import { render, staticRenderFns } from "./GlobalFooterSnsLink.vue?vue&type=template&id=2b3457c8&"
import script from "./GlobalFooterSnsLink.vue?vue&type=script&lang=ts&"
export * from "./GlobalFooterSnsLink.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalFooterSnsLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports